export const USER_VERIFICATION_ATTEMPT = "USER_VERIFICATION_ATTEMPT";
export const USER_VERIFICATION_SUCCESS = "USER_VERIFICATION_SUCCESS";
export const USER_VERIFICATION_FAILED = "USER_VERIFICATION_FAILED";
export const USER_VERIFICATION_SUBMIT_ATTEMPT = "USER_VERIFICATION_SUBMIT_ATTEMPT";
export const USER_VERIFICATION_SUBMIT_SUCCESS = "USER_VERIFICATION_SUBMIT_SUCCESS";
export const USER_VERIFICATION_SUBMIT_FAILED = "USER_VERIFICATION_SUBMIT_FAILED";
